module.exports = __webpack_public_path__ + "img/thumb-andrea-off.34b23600.jpg";